import { render, staticRenderFns } from "./UserCoupon.vue?vue&type=template&id=7437cd96&scoped=true"
import script from "./UserCoupon.vue?vue&type=script&lang=js"
export * from "./UserCoupon.vue?vue&type=script&lang=js"
import style0 from "./UserCoupon.vue?vue&type=style&index=0&id=7437cd96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7437cd96",
  null
  
)

export default component.exports